<div class="fullcontainer">
  <br />
  <br />

  @if (this.isServerError) {
    <div class="alert alert-danger noPrint">Something went wrong. Please try again later.</div>
  }

  <div class='titleContainer noPrint'>
    <h2 class='header' style='color: #006498'>Location Label - {{ this.getShelf() }}</h2>

    <div>
      <button class='btn btn-secondary' (click)='this.print()'><i class="fas fa-print"></i> Print</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/warehousing/locations'><i class="fas fa-arrow-left"></i> Back</button>&nbsp;
    </div>
  </div>
  <app-label-print-setup></app-label-print-setup>
  <br />

  <app-stock-label
    scanType='location'
    [recordId]='this.warehouseLocation.id'
    [title]='this.getShelf()'
    [subtitle]='this.getWarehouseName()'
    [reference]='this.warehouseLocation.description'
  ></app-stock-label>
</div>
